import AdvancedInput from '../form-inputs/advancedInput';
import InformationText from '../InformationText';
import SplitLayout from '../splitLayout';

export default function ViewerPanel({ user }: { user: Record<string, string> }) {
  return (
    <SplitLayout leftWeight="md:w-4/12" rightWeight="flex-wrap md:w-8/12">
      <InformationText title="Personal Information" subtitle="Personal Information" />
      {Object.entries(user).map(([key, value]) => (<AdvancedInput key={`${key}-${value}`} type="text" id={key} label={key} value={value} disabled />
      ))}
    </SplitLayout>
  );
}
